import I18n from "^/config/i18n";

function FetchMoreButton({ show, fetching, onClick }) {
  if (!show) {
    return null;
  }
  return (
    <div className="row mb-4">
      <div className="col text-center">
        <button onClick={onClick} className="btn bg-blue">
          {fetching && (
            <i className="las la-spinner la-spin me-2" aria-hidden="true" />
          )}
          {fetching && <span className="sr-only">{I18n.t("loading")}</span>}
          {I18n.t("load_more_news")}
        </button>
      </div>
    </div>
  );
}
export default FetchMoreButton;
